// Response data's from server
let tangent_facemap_data;

var tangent_selfie_id;

// Product ID to single Variant ID mapping
var tangent_selected_product_map;

var default_addToCartText = "Add to Cart";
var default_addedToCartText = "Added to Cart!";
var out_of_stock_text = "Out Of Stock";
var no_products_found_text ="No Products were found";
const default_add_all_to_cart_text = "Add All to Cart"

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};

// Add default image url here
var tangent_default_selfie_image_url="https://haleysbeauty.com/cdn/shop/files/haleys_complexion_model.png?v=1762224462&width=460";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper");
var tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message");
var tangent_read_more_label = tangent_sections_wrapper_element
  ? tangent_sections_wrapper_element.getAttribute("data-read-more-label") || "Read more"
  : "Read more";
var tangent_hide_label = tangent_sections_wrapper_element
  ? tangent_sections_wrapper_element.getAttribute("data-hide-label") || "Show less"
  : "Show less";

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, function(character) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[character];
  });
}


window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function attachScrollToEvent(){
    document.querySelectorAll(".scroll-to-btn").forEach((element)=>{
        element.addEventListener("click", ()=>{
            const target = document.getElementById(element.dataset.scrollto);
            if(target){
                const top = target.getBoundingClientRect().top + window.pageYOffset - 40 ;
                window.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            }
        })
    })
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;
  
    // API call for facemapping
    if(response["selfie_id"]!=null){
      setSelfieId(response["selfie_id"]);
    }
  
    tangent_client_domain_currency = '$'

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);

      // Setting 1st tab active by default
      document.querySelector("#tab-wrapper").style.display="block";
    }
    
    if(response.text_sections!=undefined){
      setLevelProductsTitle(tangent_text_sections);
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    setElementDisplay("section_selfie_container_parent","flex");
    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants, tangent_text_sections);
      enableButtonListener();
      loadElementsOnResponseData(); 
    }
}

function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

function getBundleProductIds(productSections) {
  const ids = productSections?.section_bundle;
  if (!Array.isArray(ids)) return new Set();
  return new Set(ids.map(String));
}

function getLevelSectionNames(productSections) {
  return Object.keys(productSections || {})
    .filter(name => /^section_level_\d+$/.test(name))
    .sort((a, b) => Number(a.replace("section_level_", "")) - Number(b.replace("section_level_", "")));
}

function setProductsToView(products, sections, selected_variants, textSections) {
  tangent_selected_product_map = {};
  const bundleProductIds = getBundleProductIds(sections);
  const bundleTitles = Array.isArray(textSections?.section_bundle) ? textSections.section_bundle : [];
  const productById = {};

  for (const product of products) {
    const id = String(product.id);
    if (!productById[id]) productById[id] = product;
  }

  const renderSection = (section, productIds, startStep) => {
    const product_section_grid = document.getElementById(section + "_product_grid");
    if (!product_section_grid) return startStep;

    const fragment = document.createDocumentFragment();
    let step = startStep;

    productIds.forEach((id, index) => {
      if (section !== "section_bundle" && bundleProductIds.has(String(id))) return;

      const product = productById[String(id)];
      if (!product) return;

      const variant = getSelectedVariant(product, selected_variants[product.id]);
      tangent_selected_product_map[product.id] = extractShopifyNumericId(variant.id);

      step += 1;
      const bundleTitle = section === "section_bundle" ? bundleTitles[index] : "";
      const product_html = getProductHTML(product, step, variant, section, sections, bundleTitle);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = product_html;

      while (tempDiv.firstChild) {
        fragment.appendChild(tempDiv.firstChild);
      }
    });

    product_section_grid.appendChild(fragment);
    return step;
  };

  let levelStep = 0;
  for (const section of getLevelSectionNames(sections)) {
    levelStep = renderSection(section, sections[section] || [], levelStep);
  }

  renderSection("section_bundle", sections.section_bundle || [], 0);
}

function getProductHTML(product, step, variant, section, sections, bundleTitle) {
  const variantId = extractShopifyNumericId(variant.id);
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant.image_id, product);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;

  let buttonClass="";
  let buttonText = default_addToCartText;
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
  }
  else{
    buttonText = out_of_stock_text;
    buttonClass ="disable-button";
  }
  
  const stepLabel = section === "section_bundle"
    ? ""
    : `<p class="step-count">Step: ${step}</p>`;

  const bundleTitleText = String(bundleTitle ?? "").trim();
  const bundleTitleHtml = section === "section_bundle" && bundleTitleText
    ? `<h2 class="tangent-selfie-description-title section_bundle_title">${escapeHtml(bundleTitleText)}</h2>`
    : "";

  // Product View HTML using template literals
  const product_html = `
    <div>
      ${stepLabel}
      ${bundleTitleHtml}

      <div>
        <a class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <img
            src="${variant_image_url}"
            class="tangent_product_image"
            alt="${product.title}"
            style="background:transparent;"
          >
        </a>
      </div>

      <div class="tangent-product-content">
        <p class="tangent_product_title_text tangent-product-title">${product.title}</p>

        <p id="price_tangent_product_${section}_${step}" class="product-grid-item__price price">
          ${tangent_client_domain_currency}${variant.price}
        </p>

        ${createReviewSummary(product)}

        <details class="product-details">
          <summary
            class="tangent-product-readmore"
            data-read-more="${escapeHtml(tangent_read_more_label)}"
            data-hide="${escapeHtml(tangent_hide_label)}"
          ></summary>
          <div class="product-help-text-wrap">
            <div class="product-help-text">
              ${removeFirstParagraph(product.descriptionHtml)}
            </div>
          </div>
        </details>

        <button
          class="tangent-product-add-btn-wrapper btn btn--primary btn--solid btn--large btn--submit product__submit__add tangent-custom-button ${buttonClass}"
          id="${variantId}"
        >
          ${buttonText}
        </button>
      </div>
    </div>
  `;
  
  return product_html;
}

function removeFirstParagraph(html) {
  return html
        .replace(/<p\b[^>]*>[\s\S]*?<\/p>\s*/i, '') // remove first paragraph
        .replace(/✔️\s*/g, ''); // remove tick marks
}

function createReviewSummary(product) {
    const averageRating = Number(product?.tangent_review_average?.value);
    const reviewCount = Number(product?.tangent_reviews_count?.value);

    if (!Number.isFinite(averageRating) || !Number.isFinite(reviewCount) || reviewCount <= 0) {
        return "";
    }

    const uniqueId = `rating_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;

    let starsHtml = "";

    for (let i = 1; i <= 5; i++) {
        let fillPercent = 0;

        if (averageRating >= i) {
            fillPercent = 100;
        } else if (averageRating > i - 1) {
            fillPercent = ((averageRating - (i - 1)) * 100).toFixed(0);
        }

        const gradientId = `${uniqueId}_star_${i}`;

        starsHtml += `
            <svg viewBox="0 0 18 18" width="15" height="15" style="margin-right:${i === 5 ? '8px' : '3.5px'};">
                <defs>
                    <linearGradient id="${gradientId}">
                        <stop offset="${fillPercent}%" stop-color="#4B3C92"></stop>
                        <stop offset="${fillPercent}%" stop-color="#FFFFFF"></stop>
                    </linearGradient>
                </defs>
                <path
                    d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z"
                    stroke="#4B3C92"
                    fill="url(#${gradientId})">
                </path>
            </svg>
        `;
    }

    return `
        <div class="tangent-review-summary">
            <div style="display:flex;align-items:center;">
                <div style="display:flex;align-items:center;height:28px;">
                    ${starsHtml}
                    <span style="
                        color:#4B3C92;
                        font-weight:700;
                        font-size:16px;
                        padding-top:2px;
                    ">
                        ${averageRating.toFixed(1)}
                    </span>
                </div>
            </div>

            <div style="
                font-weight:700;
                font-size:16px;
                color:#2C2C2C;
                line-height:28px;
                display: flex;
            ">
                ${reviewCount} Review${reviewCount !== 1 ? 's' : ''}
            </div>
        </div>
    `;
}

function getSelectedVariant(product, variant_list) {
    const productVariants = product.variants || [];
    if (productVariants.edges.length === 0) {
        throw new Error("No variants available for the product.");
    }
    if (variant_list.length > 0) {
        const selectedVariantId = Number(variant_list[0]);

        const matchedVariant = productVariants.edges.find(edge =>
            extractShopifyNumericId(edge.node.id) === selectedVariantId
        );

        return matchedVariant?.node || productVariants.edges[0].node;
    }
    return productVariants.edges[0].node;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

function extractShopifyNumericId(gid) {
    if (typeof gid !== 'string') return null;

    const match = gid.match(/\d+$/);
    return match ? Number(match[0]) : null;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid, sectionName) {
    if (!product_sections) return;

    const sectionsToUpdate = sectionName ? [sectionName] : Object.keys(product_sections);

    for (const section of sectionsToUpdate) {
        if ((product_sections[section] || []).map(String).includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}`);
                if (addAllButton) {
                    // addAllButton.style.display = sectionData.count > 1 ? "flex" : "none";
                }
            }
        }
        console.log(sections_add_to_cart_map);
    }
}


// Add all to cart function for sections
function addAllTocartFunction(element) {
  console.log("element",element);
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}


const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => {
      const item = {
        id: Number(id),
        quantity: 1
      };
      return item;
    })
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const sectionProducts = sections_add_to_cart_map[element.id];
  if (!sectionProducts || !sectionProducts.list.length) return;

  addToCartApi(createFormDataFromIds(sectionProducts.list), element);
}

function addToCartApi(payload, element){
  const originalLabel = element.innerHTML;
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(response => {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style");
    if (window.cart && typeof window.cart.getCart === "function") {
      window.cart.getCart();
    }
    setTimeout(() => {
      element.innerHTML = originalLabel;
      element.classList.remove("added-to-cart-style");
    }, 4000);
  }).catch((error) => {
      console.error('Error:', error);
      element.innerHTML = originalLabel;
  });
}

const createElement = (button_id, element_type) =>{
  const element = document.createElement(element_type);
  element.id=button_id;
  return element;
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    
    return section_container;
}

function createSectionAddAllToCart(section_name) {
    const button = document.createElement("button");

    button.id = `${section_name}`;

    button.classList.add(
        "section_add_all_to_cart",                 // common
        `${section_name}_add_all_to_cart`,        // section specific
        "btn",
        "btn--primary",
        "btn--solid",
        "btn--large",
        "btn--submit",
        "product__submit__add"
    );

    button.innerHTML = default_add_all_to_cart_text;

    button.setAttribute(
        "aria-label",
        `Add all ${section_name} items to cart`
    );

    button.addEventListener("click", () =>
        addAllTocartFunction(button)
    );

    return button;
}

function addSectionProductGridContainer(sectionName) {
    const productGrid = document.createElement("div");

    productGrid.id = `${sectionName}_product_grid`;
    productGrid.classList.add(
        "section_product_grid",
        `${sectionName}_product_grid`
    );
    return productGrid;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    const bundleProductIds = getBundleProductIds(product_sections);

    for (const section_name of getLevelSectionNames(product_sections)) {
      const visibleIds = (product_sections[section_name] || []).filter(id => !bundleProductIds.has(String(id)));
      if (!visibleIds.length) continue;

      var section_container = createSectionContainer(section_name);

      // Button is first in the DOM so column-reverse places it under the products
      section_container.appendChild(createSectionAddAllToCart(section_name));
      section_container.appendChild(addSectionProductGridContainer(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }

    createBundleSection(product_sections);
}

function createBundleSection(product_sections) {
    const bundleIds = product_sections?.section_bundle;
    if (!Array.isArray(bundleIds) || bundleIds.length === 0) return;

    const bundleRoot = document.querySelector("#tangent-bundle-container");
    if (!bundleRoot) return;

    const section_container = createSectionContainer("section_bundle");

    section_container.appendChild(addSectionProductGridContainer("section_bundle"));
    section_container.appendChild(createSectionAddAllToCart("section_bundle"));
    bundleRoot.appendChild(section_container);
}

function getLevelProductsTitle(textSections) {
    const levelNames = Object.keys(textSections || {})
        .filter(name => /^section_level_\d+$/.test(name))
        .sort((a, b) => Number(a.replace("section_level_", "")) - Number(b.replace("section_level_", "")));

    for (const name of levelNames) {
        const items = textSections[name];
        if (!Array.isArray(items)) continue;

        const title = items
            .map(item => String(item).trim())
            .find(item => item && !item.startsWith("<"));

        if (title) return title;
    }

    return "";
}

function setLevelProductsTitle(textSections) {
    const heading = document.querySelector(".tangent-selfie-description-title");
    if (!heading) return;

    const title = getLevelProductsTitle(textSections);
    if (!title) {
        heading.remove();
        return;
    }

    heading.textContent = title;
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections) {

    Object.entries(text_sections).forEach(([section_name, section_content]) => {

        // Skip if product section already exists
        if (product_sections[section_name] !== undefined) return;

        const section_container = createSectionContainer(section_name);

        const section_div = document.createElement("div");

        section_div.id = `${section_name}_text_container`;

        section_div.classList.add(
            "section_text_container",
            `${section_name}_text_container`
        );
        
        section_div.innerHTML = section_content.join(" ");

        if(section_div.querySelector(".routine-shop-btn")){
          section_div.querySelector(".routine-shop-btn").addEventListener("click", handleRoutineShop);
        }

        section_container.appendChild(section_div);

        // Special placements
        const specialContainers = {
            section_selfie: "#section_selfie_container_parent",
            section_level_3: "#section_selfie_container_parent",
            section_footer: "#tangent-footer-section"
        };

        const targetSelector = specialContainers[section_name];

        if (targetSelector) {

            const targetElement = document.querySelector(targetSelector);

            section_container.classList.remove("tabcontent");

            targetElement?.appendChild(section_container);

        } else {

            // Default placement
            tangent_sections_wrapper_element.appendChild(section_container);

        }

    });
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
   
  hideLoading();
  if(response.selfie_url!=undefined && response.selfie_url!=null){
    // hideHightlightButtonDisplayToggle("flex");
    const canvasImage = document.querySelector('#canvas_img');
    canvasImage.src = response.selfie_url;
    canvasImage.style.display="flex";
  }
  else{
      if(tangent_default_selfie_image_url!=""){
          hideLoading();
          showSelfieImage();
          document.querySelector('#canvas_img').src = tangent_default_selfie_image_url;
      }
      else{
          document.querySelector("#tangent_selfie_container").style.display = "none";
      }
  }
    
}

// Enabling button listeners
function enableButtonListener() {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.tangent-product-add-btn-wrapper');
    if (!btn) return;

    addToCart(btn);
  });

  document.addEventListener('click', function (event) {
    const summary = event.target.closest('.tangent-product-readmore');
    if (!summary) return;

    const details = summary.closest('.product-details');
    const wrap = details?.querySelector('.product-help-text-wrap');
    if (!details || !wrap) return;

    event.preventDefault();
    if (details.dataset.animating === 'true') return;

    details.dataset.animating = 'true';

    const finish = (transitionEvent) => {
      if (transitionEvent.target !== wrap || transitionEvent.propertyName !== 'grid-template-rows') return;
      wrap.removeEventListener('transitionend', finish);
      if (!details.classList.contains('is-open')) {
        details.removeAttribute('open');
      }
      details.dataset.animating = 'false';
    };

    wrap.addEventListener('transitionend', finish);

    if (details.classList.contains('is-open')) {
      details.classList.remove('is-open');
      return;
    }

    details.setAttribute('open', '');
    requestAnimationFrame(() => details.classList.add('is-open'));
  });

  // document.addEventListener('click', function (e) {
  //   const btn = e.target.closest('.oil-routine-button');
  //   if (!btn) return;

  //   addAllTocartFunction(btn);
  // });
  
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

// Show Selfie Image
function showSelfieImage(){
  document.querySelector("#canvas_img").style.display = "block";
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

function loadElementsOnResponseData() {
  const allElements = document.querySelectorAll('.load-on-data');
  allElements.forEach(el => {
    el.style.display = el.dataset.originalDisplay || 'block';
  });
}

function handleRoutineShop() {
  console.log("triggered btn")
  const addAllToCartBtn = document.querySelector(".section_add_all_to_cart");
  if(!addAllToCartBtn) return;
  addAllToCartBtn.click();
}
